export enum NotificationEmailTypeEnum {
  NO_SEND = 0,
  USE_GLOBAL_ADDRESS = 1,
  USE_CUSTOM_ADDRESS = 2,
}